import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=bab75eca&"
import script from "./FormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab75eca')) {
      api.createRecord('bab75eca', component.options)
    } else {
      api.reload('bab75eca', component.options)
    }
    module.hot.accept("./FormBuilder.vue?vue&type=template&id=bab75eca&", function () {
      api.rerender('bab75eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder.vue"
export default component.exports